import { render, staticRenderFns } from "./SliceFeatured.vue?vue&type=template&id=b9f654ae&scoped=true"
import script from "./SliceFeatured.vue?vue&type=script&lang=js"
export * from "./SliceFeatured.vue?vue&type=script&lang=js"
import style0 from "./SliceFeatured.vue?vue&type=style&index=0&id=b9f654ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f654ae",
  null
  
)

export default component.exports